import React from 'react';
import { NavLink } from 'react-router-dom';
import './PublicBottomBar.css';

const items = [
  { path: '/', icon: 'fas fa-home', label: 'Home', end: true },
  { path: '/tornei/iscrizioni', icon: 'fas fa-trophy', label: 'Tornei' },
  { path: '/tornei/statistiche', icon: 'fas fa-chart-bar', label: 'Statistiche' },
  { path: '/foto', icon: 'fas fa-camera', label: 'Foto' },
];

/** Bottom-bar di navigazione rapida per le pagine pubbliche (solo mobile/tablet). */
const PublicBottomBar = () => {
  return (
    <nav className="public-bottom-bar" aria-label="Navigazione rapida">
      <div className="pbb-container">
        {items.map((it) => (
          <NavLink
            key={it.path}
            to={it.path}
            end={it.end}
            className={({ isActive }) => `pbb-item ${isActive ? 'active' : ''}`}
          >
            <i className={`${it.icon} pbb-icon`}></i>
            <span className="pbb-label">{it.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default PublicBottomBar;
